import * as React from 'react';

import {useTranslation} from 'common/i18n/hooks';
import {BooleanOperator} from 'common/widgets/property-filter-menu/models/types';
import {RadioButtonReact} from 'common/components/radio-button';

import {FilterValueProps} from '../types';

export function FilterBooleanValue(props: FilterValueProps) {
  const {t} = useTranslation();
  return (
    props.hasNewUI && (
      <div className='radio-btns'>
        <RadioButtonReact
          className='radio-btn'
          selected={props.filter.filterOperator === BooleanOperator.True}
          onClick={() => props.onChange(true)}
        >
          {t(`filters.boolean-operator.true`)}
        </RadioButtonReact>
        <RadioButtonReact
          className='radio-btn'
          selected={props.filter.filterOperator === BooleanOperator.False}
          onClick={() => props.onChange(false)}
        >
          {t(`filters.boolean-operator.false`)}
        </RadioButtonReact>
      </div>
    )
  );
}
